// @flow

import type { AbsenceReasonsState } from "./types";

export const initialState: AbsenceReasonsState = {
  requestsInProgress: 0,
  options: {
    absenceReasons: [],
  },
};

export default initialState;
